






import { LoginService } from "@/services/login.service";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Permissao extends Vue {
  @Prop({ required: true })
  requiredRoles!: string | string[];

  haveAccess = false;

  @Watch("requiredRoles", { immediate: true })
  @Emit()
  onRequiredRolesChange() {
    LoginService.GetRoleUsuario().then((roles) => {
      const permissaoNecessaria = (Array.isArray(this.requiredRoles) &&
        this.requiredRoles) || [this.requiredRoles];

      if(permissaoNecessaria.map(perm => perm.startsWith('!')).indexOf(true) > -1){
        if(permissaoNecessaria.map(perm => perm.startsWith('!')).indexOf(false) > -1){
          console.error('Para validação de negação de função é necessário que todo o array seja de funções negadas');
          this.haveAccess = false;
        }

        this.haveAccess = permissaoNecessaria.map(perm => roles.indexOf(perm.substring(1)) > -1).indexOf(true) == -1;
      }else{
        this.haveAccess = permissaoNecessaria.map(perm => roles.indexOf(perm) > -1).indexOf(true) > -1;
      }

      this.$emit('onHaveAccessChange', this.haveAccess);
    });
  }
}
